module.exports = __webpack_public_path__ + "static/media/phoneInteractionIcon.53bf4c2e.svg";